import React, { useEffect, useRef, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logo from "../../assets/images/smartLogoMain.png";
import gold from "../../assets/images/goldbadge-bg.png";
import blue from "../../assets/images/bluebadge-bg.png";
import silver from "../../assets/images/silverbadge-bg.png";
import { QRCodeCanvas } from 'qrcode.react';
import './certificate.component.css'
import { getMemberShipList } from '../../services/subscription.service';

const formatDate = (dateString) => {
  if (!dateString) return '-';
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};

const CertificateComponent = ({ userData }) => {
  const certificateRef = useRef(null);
  const [membershipStyles, setMembershipStyles] = useState({});

  useEffect(() => {
    async function fetchAndMapStyles() {
      try {
        const list = await getMemberShipList();
        const mappedStyles = {};

        list.forEach(member => {
          const rawName = member.subscriptionName || '';
          const name = rawName.toLowerCase();
          let badge = 'silver';
          if (name.includes('life fellow')) {
            badge = 'gold';
          } else if (name.includes('life senior member') || name.includes('life member') || name.includes('senior')) {
            badge = 'blue';
          } else if (name.includes('annual student member') || name.includes('annual member') || name.includes('annual')) {
            badge = 'silver';
          }

          // Define color sets based on badge
          let styleSet = {
            borderColor: 'rgb(145 145 145)',
            bgColor: '#f0f0f0',
            textColor: '#000',
          };

          if (badge === 'gold') {
            styleSet = {
              borderColor: '#d4af37',
              bgColor: '#fffaf0',
              textColor: '#000',
            };
          } else if (badge === 'blue') {
            styleSet = {
              borderColor: '#007bff',
              bgColor: '#e7f1ff',
              textColor: '#000',
            };
          }

          mappedStyles[rawName] = {
            title: rawName,
            badge,
            ...styleSet,
          };
        });

        setMembershipStyles(mappedStyles);
      } catch (error) {
        console.error("Error loading membership styles", error);
      }
    }

    fetchAndMapStyles();
  }, [userData]);

  const userStyle = Object.values(membershipStyles).find(e => e.title === userData?.subscriptionType) || {};
  const { title, borderColor, bgColor, textColor, badge } = userStyle;

  const downloadPDF = async () => {
    const input = certificateRef.current;
    const canvas = await html2canvas(input, { scale: 3, useCORS: true });
    const imgData = canvas.toDataURL('image/jpeg', 0.85);
    const pdf = new jsPDF('landscape', 'pt', 'a4', true);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`certificate_${userData?.membershipNo}.pdf`);
  };

  return (
    <div className="subscription-wrap">
      <main>
        <div className="card-certificate">
          <div className="certificate-scroll-container">
            <div
              ref={certificateRef}
              className="certificate-content"
              style={{
                width: '1000px',
                padding: '40px',
                border: `6px solid ${borderColor}`,
                backgroundColor: bgColor,
                color: textColor,
                borderRadius: '0px',
                boxShadow: '0 0 25px rgba(0,0,0,0.2)',
                fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                position: 'relative',
              }}
            >
              {/* Header with Logo and Title */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className='certificate-qrcode'>
                  <QRCodeCanvas value={userData?.membershipNo || 'N/A'} size={80} />
                  <div className='certificate-no'>
                    <strong>{userData?.membershipNo}</strong>
                  </div>
                </div>
                <img
                  src={logo}
                  alt="SMART"
                  style={{ height: '100px' }}
                />
                <h2 className="text-center flex-grow-1 certificate-header">
                  Society for Microwaves, Antennas and Radar Technologies <span className='certificate-smart'>(SMART)</span>
                </h2>
                <div style={{ width: '100px' }} />
              </div>

              {/* Certificate Title */}
              <div className="text-center my-4">
                <div className='certificate-name'>
                  {
                    badge === 'gold' ? (
                      <img className='certificate-badge' src={gold} alt="Certificate Badge" />
                    ) : badge === 'silver' ? (
                      <img className='certificate-badge' src={silver} alt="Certificate Badge" />
                    ) : (
                      <img className='certificate-badge' src={blue} alt="Certificate Badge" />
                    )
                  }
                  Certificate of {title}
                </div>
              </div>

              {/* Paragraph */}
              <div className="text-center my-4 px-5">
                <p className='certificate-para'>
                  This is to certify that
                  <span className='certificate-font'> {userData?.subscriberName || ''} </span>
                  has been duly awarded as a “<span className='certificate-font'>{title}</span>” member of the <span className='certificate-font'>SMART</span> in recognition of his/her/their
                  continued support, dedication and valued association with the objectives and ideals of the Society.
                </p>
                <br />
                <p className='certificate-para'>
                  This <span className='certificate-font'>{title} Membership</span> is conferred with all the rights, privileges, and responsibilities
                  accorded by the Society and shall remain valid for {badge === 'silver' ? 'one year.' : 'the lifetime of the member.'}

                </p>
              </div>

              {/* Validity */}
              <div className="text-center my-4">
                <p className="certificate-date">
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Valid From: <strong>{formatDate(userData?.subscriptionStartDate) || '-'}</strong>
                  {
                    badge !== 'gold' && (
                      <>
                        &nbsp; | &nbsp; Valid Till: <strong>{formatDate(userData?.subscriptionEndDate) || '-'}</strong>
                      </>
                    )
                  }
                </p>
              </div>

              {/* Signature */}
              <div className="d-flex justify-content-between mt-5 pe-2" style={{ paddingLeft: '40px' }}>
                <div className="text-center">
                  <p className='certificate-sign'>Gampala Viswam</p>
                  <p style={{ marginTop: '-15px' }}>President</p>
                </div>
                <div className="text-center">
                  <p className='certificate-sign'>Dr. Somsing Rathod</p>
                  <p style={{ marginTop: '-15px' }}>General Secretary</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-4">
            <button className="btn btn-primary px-4 py-2" onClick={downloadPDF}>
              Download as PDF
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CertificateComponent;
